// Format a phone number as XXX-XXX-XXXX as the user types. Strips non-digits and
// caps at 10 (US). Single source of truth for every phone field in the app.
export function formatPhone(value) {
  const d = String(value || '').replace(/\D/g, '').slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
}
